import { FontWeights, getTheme, IStackStyles, ITextStyles, Stack } from "@fluentui/react";
import React, { ReactNode } from "react";
import { Text } from "sprint-common-web";

export interface PageHeaderProps {
    title?: string;
    children?: ReactNode;
}

const titleStyles: ITextStyles = {
    root: {
        color: getTheme().palette.neutralPrimary,
        fontSize: 20,
        fontWeight: FontWeights.semibold
    }
};

const pageHeaderStyles: IStackStyles = {
    root: {
        paddingTop: 20,
        paddingBottom: 20,
        width: "100%",
        height: 60
    }
};

export const PageHeader: React.FunctionComponent<PageHeaderProps> = (props: PageHeaderProps) => {
    const { title, children } = props;

    const getContent = () => {
        if (title) {
            return <Text styles={titleStyles}>{props.title}</Text>;
        }

        return children;
    };

    return (
        <Stack horizontal={true} horizontalAlign="space-between" verticalAlign="center" styles={pageHeaderStyles}>
            {getContent()}
        </Stack>
    );
};
